import axios from "axios";

const transport = axios.create({
    // baseURL: "http://192.168.1.4:8003/api/v1",
    baseURL: "https://portalapi.ztripplus.com/api/v1",
    // baseURL: "https://testapi.ztripplus.com/api/v1",
});

transport.interceptors.request.use((config) => {

    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'default';
    config.headers['local'] = currentLanguageCode;
    return config;
}, (error) => {
    return Promise.reject(error);
});
transport.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error("Unauthorized! Redirecting to login...");
            localStorage.removeItem('accessToken');
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default transport;
